<mat-toolbar color="primary">
  <mat-toolbar-row>
    <div fxFlex fxLayout="row" fxLayoutAlign="flex-end">
      <mat-icon class="userIcon">account_circle</mat-icon>
      <div class="userInfo">
        <p class="userDetail">{{loggedInUser}}</p>
        <p class="signOut" (click)="onSignOut()" i18n>LOGOUT</p>
        <!-- <div class="logoutRow">
          
          <p class="timeDisplay">
            <strong> {{ count }} s</strong>
          </p>
        </div>       -->
      </div>
    </div>
  </mat-toolbar-row>